module.exports = __webpack_public_path__ + "static/media/sprinkler.788642b2.svg";